module.exports = __webpack_public_path__ + "media/application/images/svgs/clipboard-f92ffbcc930aec006fefb1c8f22a8e7b.svg";